import * as React from "react"
import { useTranslation } from "react-i18next"

import { useUIPreferences } from "Catalog/shared/components/UIPreferencesContext"
import { IProduct } from "shared/hubrise/models"

import FoldableSection from "../FoldableSection"

import MultiSku from "./MultiSku"
import SingleSku from "./SingleSku"

interface OptionListsProps {
  product: IProduct
}

const OptionLists = ({ product }: OptionListsProps): JSX.Element => {
  const { t } = useTranslation()
  const { optionListsExpanded, setOptionListsExpanded } = useUIPreferences()

  return (
    <div data-testid="option-lists">
      <FoldableSection
        title={t("product.option_lists.title")}
        expanded={optionListsExpanded}
        onToggle={() => setOptionListsExpanded(!optionListsExpanded)}
      >
        {product.skus.length === 1 ? <SingleSku product={product} /> : <MultiSku product={product} />}
      </FoldableSection>
    </div>
  )
}

export default OptionLists
